export default "__VITE_ASSET__BGpfjTgf__"